var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002793"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D25333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3592 7.69232L8.37624 13.0769L5.38477 10.3846",
    fill: "#D25333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3592 7.69232L8.37624 13.0769L5.38477 10.3846",
    stroke: "white",
    strokeWidth: 1.74651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFilled);
export default __webpack_public_path__ + "static/media/tick_filled.70289ca2d955218f48b062a821d000a5.svg";
export { ForwardRef as ReactComponent };